import * as React from 'react';
import Input from '../input/Input';
import {IconButton} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import {
    Link,
  } from "react-router-dom";
 
class Search extends React.Component<any, { keyword: string }> {
  public mounted : boolean = false;
  constructor(props: any) {
    super(props);
    this.state = {
      keyword: ""
    };
    this.setKeyword = this.setKeyword.bind(this);
  }

  public componentDidMount() {
    this.mounted = true;
  }

  public componentWillUnmount(){
    this.mounted = false;
  }

  public setKeyword(keyword: string) {
    if (this.mounted) {
      this.setState({ keyword });
    }
  }

  public render() {
    const link: string = "/search/query=" + this.state.keyword;
    const myLink = (props: any) => <Link to={link} {...props} />;
    return (
      <div className="rowH">
        <div className="columnIn">
          <Input
            id="search"
            labelName=" "
            inputType="text"
            placeholder="Search..."
            fullWidth={true}
            parentFunction={this.setKeyword}
          />
        </div>
        <div className="columnIc">
          <IconButton aria-label="Search" color="primary" component={myLink}>
            <SearchIcon />
          </IconButton>
        </div>
      </div>
    );
  }
}
export default Search;







// WEBPACK FOOTER //
// ./src/components/home/Search.tsx